import { render, staticRenderFns } from "./RankZone.vue?vue&type=template&id=455588a4&scoped=true"
import script from "./RankZone.vue?vue&type=script&lang=js"
export * from "./RankZone.vue?vue&type=script&lang=js"
import style0 from "./RankZone.vue?vue&type=style&index=0&id=455588a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455588a4",
  null
  
)

export default component.exports